import { useCallback } from "react";
import { useDesignCommandManager } from "@/store/zustand/designCommandManagerStore";
import {
  useSelectedNavTreeNode,
  useMultiselectedNavTreeNode,
} from "@/components/Canvas/stores/canvasStore";
import { TempoElement } from "@/utils/tempoElement";
import { WrapDivChange } from "@/store/zustand/changeLedgerTypes";
import { v4 as uuidv4 } from "uuid";

export const useGroupElements = () => {
  const { selectedElement } = useSelectedNavTreeNode();
  const { multiselectedElements } = useMultiselectedNavTreeNode();

  return useCallback(() => {
    if (!selectedElement || selectedElement.isEmpty()) return;

    const codebaseIdsToWrap = multiselectedElements?.length
      ? multiselectedElements
          .slice()
          .sort((a, b) => a.uniquePath.localeCompare(b.uniquePath))
          .map((tempoElement) => tempoElement.codebaseId)
      : [selectedElement.codebaseId];

    if (!codebaseIdsToWrap?.length) return;

    const newCodebaseId = `tempo-${uuidv4()}`;
    const change = new WrapDivChange({
      codebaseIdsToWrap,
      newCodebaseId,
    });

    const newSelectedElement = new TempoElement(
      newCodebaseId,
      selectedElement.storyboardId,
      selectedElement.uniquePath,
    );
    change.setSelectedElementsAfterInstantUpdate(
      newSelectedElement.getKey(),
      null,
    );

    useDesignCommandManager.getState().executeCommand(change);
  }, [multiselectedElements, selectedElement]);
};
